import { Component, Input } from '@angular/core';
import { Labels } from 'src/interfaces/enums.model';

/** Порядок «язычков» на фото — одинаковый в списке и в карточке блюда */
const ORDER = [
  Labels.hit,
  Labels.spicy,
  Labels.premiere,
  Labels.vegan,
  Labels.protein,
  Labels.nonalcohol,
  Labels.alcohol,
  Labels.pork,
];

/**
 * Маркеры позиции — «язычки» у правого края фото: в карточке в списке и в
 * карточке блюда (диалоге). Положение задаёт родитель
 */
@Component({
    selector: 'app-label-banners',
    templateUrl: './menu-label-banners.component.html',
    styleUrls: ['./menu-label-banners.component.css'],
    standalone: false
})
export class MenuLabelBannersComponent {
  @Input() labels: Labels[] = [];

  readonly Labels = Labels;

  get shown(): Labels[] {
    return ORDER.filter((label) => this.labels?.includes(label));
  }
}
